import api from './axiosInstance';

export const getAdminUsersApi       = (params) => api.get('/admin/users', { params });
export const getSubscriptionsApi    = (params) => api.get('/get-subscriptions', { params });
export const addSubscriptionApi = (data) => api.post('/admin/users/subscription', data);
export const remindSubscribeApi = (data) => api.post('/admin/users/remind-subscribe', data);
export const getAdminUserReferralsApi = (params) => api.get('/admin/users/referrals', { params });
export const getAdminPromotersApi = (params) => api.get('/admin/users/promoters', { params });
export const getAdminPlansApi = () => api.get('/plans');
export const getAdminRedeemBalanceApi = (params) => api.get('/admin/redeem-balance', { params });
export const markRedeemPaidApi = (data) => api.post('/admin/redeem-balance/mark-paid', data);
export const getHelpSuggestionsApi = (params) => api.get('/admin/help-suggestions', { params });
export const updateHelpStatusApi = (data) => api.post('/admin/help-suggestions/update-status', data);
export const sendNotificationApi = (formData) => api.post('/send-notification', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const sendNotificationUserApi = (data) => api.post('/send-notification-user', data);
export const getAdminUserCropsApi   = (params) => api.get('/admin/users/crops', { params });
export const getAdminCropUsersApi   = (params) => api.get('/admin/crop-users', { params });
export const getAdminCropUserStatesApi = () => api.get('/admin/crop-users/states');
export const getAdminCropMapApi     = (params) => api.get('/admin/crop-map', { params });
